<div class="tt-toolbar_left">
  @if (isMobile()) {
    <button class="tt-toolbar_item" (click)="expanded.set(!expanded())">
      <mat-icon [icon]="expanded() ? 'x' : 'three-dots-horizontal'" [iconSize]="iconSize()" />
    </button>
  }

  @if (expanded() || !isMobile()) {
    <button
      class="tt-toolbar_item tt-toolbar_item--zoom-in"
      [ttTooltip]="'ZoomIn' | transloco"
      [ttTooltipPositionKey]="'left'"
      (click)="handleToolbarItemClicked(FlowchartToolbarEvent.ZOOM_IN)">
      <mat-icon [icon]="'plus'" [iconSize]="iconSize()" />
    </button>

    <button
      class="tt-toolbar_item tt-toolbar_item--zoom-out"
      [ttTooltip]="'ZoomOut' | transloco"
      [ttTooltipPositionKey]="'left'"
      (click)="handleToolbarItemClicked(FlowchartToolbarEvent.ZOOM_OUT)">
      <mat-icon [icon]="'minus'" [iconSize]="iconSize()" />
    </button>

    <button
      class="tt-toolbar_item tt-toolbar_item--scale-to-fit"
      [ttTooltip]="'FitContentToView' | transloco"
      [ttTooltipPositionKey]="'left'"
      (click)="handleToolbarItemClicked(FlowchartToolbarEvent.SCALE_CONTENT_TO_FIT)">
      <mat-icon [icon]="'fullscreen'" [iconSize]="iconSize()" />
    </button>

    <button
      class="tt-toolbar_item tt-toolbar_item--focus-start"
      [ttTooltip]="'FocusStartNode' | transloco"
      [ttTooltipPositionKey]="'left'"
      (click)="handleToolbarItemClicked(FlowchartToolbarEvent.FOCUS_START)">
      <mat-icon [icon]="'loader'" [iconSize]="iconSize()" />
    </button>

    @if (canExportAsPng()) {
      <button
        class="tt-toolbar_item tt-toolbar_item--export-png"
        [ttTooltip]="'Flowchart.ExportAsPng' | transloco"
        [ttTooltipPositionKey]="'left'"
        (click)="handleToolbarItemClicked(FlowchartToolbarEvent.EXPORT)">
        <mat-icon [icon]="'file-image'" [iconSize]="iconSize()" />
      </button>
    }

    @if (canExportPdf()) {
      <button
        class="tt-toolbar_item tt-toolbar_item--export-pdf"
        [ttTooltip]="'Flowchart.ExportAsPdf' | transloco"
        [ttTooltipPositionKey]="'left'"
        (click)="handleToolbarItemClicked(FlowchartToolbarEvent.EXPORT_PDF)">
        <mat-icon [icon]="'file-pdf'" [iconSize]="iconSize()" />
      </button>
    }

    @if (!fullScreenMode() && !isMobile()) {
      <button
        class="tt-toolbar_item tt-toolbar_item--focus-start"
        [ttTooltip]="'Expand' | transloco"
        [ttTooltipPositionKey]="'left'"
        (click)="handleToolbarItemClicked(FlowchartToolbarEvent.EXPAND)">
        <mat-icon [icon]="'expand'" [iconSize]="iconSize()" />
      </button>
    }
  }
</div>
<div class="tt-toolbar_right">
  @if (!fullScreenMode() && isMobile()) {
    <button class="tt-toolbar_item" (click)="handleToolbarItemClicked(FlowchartToolbarEvent.EXPAND)">
      <mat-icon [icon]="'expand'" [iconSize]="iconSize()" />
    </button>
  }
</div>
